import { v4 as uuidv4 } from 'uuid';

const getData = (name) => {

    let id = uuidv4();

    return JSON.stringify({
        "merchant_id": `${id}`,
        "merchant_name": name,
        "merchant_details": {
            "primary_contact_person": "John Test",
            "primary_email": "JohnTest@test.com",
            "primary_phone": "sunt laborum",
            "secondary_contact_person": "John Test2",
            "secondary_email": "JohnTest2@test.com",
            "secondary_phone": "cillum do dolor id",
            "website": "www.example.com",
            "about_business": "Online Retail with a wide selection of organic products for North America",
            "address": {
                "line1": "Juspay Router",
                "line2": "Koramangala",
                "line3": "Stallion",
                "city": "Bangalore",
                "state": "Karnataka",
                "zip": "560095",
                "country": "IN"
            }
        },
        "return_url": "www.example.com/success",
        "webhook_details": {
            "webhook_version": "1.0.1",
            "webhook_username": "ekart_retail",
            "webhook_password": "password_ekart@123",
            "payment_created_enabled": true,
            "payment_succeeded_enabled": true,
            "payment_failed_enabled": true
        },
        "routing_algorithm": "custom",
        "custom_routing_rules": [
            {
                "payment_methods_incl": [
                    "card",
                    "card"
                ],
                "payment_methods_excl": [
                    "card",
                    "card"
                ],
                "payment_method_types_incl": [
                    "credit",
                    "credit"
                ],
                "payment_method_types_excl": [
                    "credit",
                    "credit"
                ],
                "payment_method_issuers_incl": [
                    "Citibank",
                    "JPMorgan"
                ],
                "payment_method_issuers_excl": [
                    "Citibank",
                    "JPMorgan"
                ],
                "countries_incl": [
                    "US",
                    "UK",
                    "IN"
                ],
                "countries_excl": [
                    "US",
                    "UK",
                    "IN"
                ],
                "currencies_incl": [
                    "USD",
                    "EUR"
                ],
                "currencies_excl": [
                    "AED",
                    "SGD"
                ],
                "metadata_filters_keys": [
                    "payments.udf1",
                    "payments.udf2"
                ],
                "metadata_filters_values": [
                    "android",
                    "Category_Electronics"
                ],
                "connectors_pecking_order": [
                    "stripe",
                    "brain_tree"
                ],
                "connectors_traffic_weightage_key": [
                    "stripe",
                    "adyen",
                    "brain_tree"
                ],
                "connectors_traffic_weightage_value": [
                    50,
                    30,
                    20
                ]
            },
            {
                "payment_methods_incl": [
                    "card",
                    "card"
                ],
                "payment_methods_excl": [
                    "card",
                    "card"
                ],
                "payment_method_types_incl": [
                    "credit",
                    "credit"
                ],
                "payment_method_types_excl": [
                    "credit",
                    "credit"
                ],
                "payment_method_issuers_incl": [
                    "Citibank",
                    "JPMorgan"
                ],
                "payment_method_issuers_excl": [
                    "Citibank",
                    "JPMorgan"
                ],
                "countries_incl": [
                    "US",
                    "UK",
                    "IN"
                ],
                "countries_excl": [
                    "US",
                    "UK",
                    "IN"
                ],
                "currencies_incl": [
                    "USD",
                    "EUR"
                ],
                "currencies_excl": [
                    "AED",
                    "SGD"
                ],
                "metadata_filters_keys": [
                    "payments.udf1",
                    "payments.udf2"
                ],
                "metadata_filters_values": [
                    "android",
                    "Category_Electronics"
                ],
                "connectors_pecking_order": [
                    "stripe",
                    "adyen",
                    "brain_tree"
                ],
                "connectors_traffic_weightage_key": [
                    "stripe",
                    "adyen",
                    "brain_tree"
                ],
                "connectors_traffic_weightage_value": [
                    50,
                    30,
                    20
                ]
            }
        ],
        "sub_merchants_enabled": false,
        "metadata": {
            "city": "NY",
            "unit": "245"
        }
    });
}

let getPaymentConnectorCreateData = (name) => {
    return JSON.stringify({
        "connector_type": "fiz_operations",
        "connector_name": name.toLowerCase(),
        "connector_account_details": {
            "auth_type": "HeaderKey",
            "api_key": "Basic c2tfdGVzdF81MUtsb1cxSFl5clBtWlJyeTlkdjB6VXZ4UVkxcUx2R3RxRlQ5WVgwNXpIQ1pIaVFQeURYWjhIM3QxbG5RR2NGWmtjMk1FNTNDTEk1MmxOMGZSanNoMGdiczAwbHNmV3hTVW46"
        },
        "test_mode": false,
        "disabled": false,
        "payment_methods_enabled": [
            {
                "payment_method": "wallet",
                "payment_method_types": [
                    "upi_collect",
                    "upi_intent"
                ],
                "payment_method_issuers": [
                    "labore magna ipsum",
                    "aute"
                ],
                "payment_schemes": [
                    "Discover",
                    "Discover"
                ],
                "accepted_currencies": [
                    "AED",
                    "AED"
                ],
                "accepted_countries": [
                    "in",
                    "us"
                ],
                "minimum_amount": 1,
                "maximum_amount": 68607706,
                "recurring_enabled": true,
                "installment_payment_enabled": true
            }
        ],
        "metadata": {
            "city": "NY",
            "unit": "245"
        }
    });
}

var paymentData = JSON.stringify({
    "amount": 6540,
    "currency": "USD",
    "confirm": true,
    "capture_method": "automatic",
    "capture_on": "2022-09-10T10:11:12Z",
    "amount_to_capture": 6540,
    "customer_id": "Newcustomer123",
    "email": "guest@example.com",
    "name": "John Doe",
    "phone": "999999999",
    "phone_country_code": "+65",
    "description": "Its my first payment request",
    "authentication_type": "no_three_ds",
    "return_url": "https://google.com",
    "payment_method": "card",
    "setup_future_usage": "on_session",
    "payment_method_data": {
        "card": {
            "card_number": "4000056655665556",
            "card_exp_month": "10",
            "card_exp_year": "25",
            "card_holder_name": "John Doe",
            "card_cvc": "123"
        }
    },
    "statement_descriptor_name": "Juspay",
    "statement_descriptor_suffix": "Router",
    "metadata": {
        "udf1": "value1",
        "new_customer": "true",
        "login_date": "2019-09-10T10:11:12Z"
    }
});

let updateMerchantAccount = (name, id, pgs) => {
    return JSON.stringify({
        "merchant_id": id,
        "merchant_name": name,
        "merchant_details": {
            "primary_contact_person": "joseph Test",
            "primary_email": "josephTest@test.com",
            "primary_phone": "veniam aute officia ullamco esse",
            "secondary_contact_person": "joseph Test2",
            "secondary_email": "josephTest2@test.com",
            "secondary_phone": "proident adipisicing officia nulla",
            "website": "www.example.com",
            "about_business": "Online Retail with a wide selection of organic products for North America",
            "address": {
                "line1": "Juspay Router",
                "line2": "Koramangala",
                "line3": "Stallion",
                "city": "Bangalore",
                "state": "Karnataka",
                "zip": "560095",
                "country": "IN"
            }
        },
        "return_url": "www.example.com/success",
        "webhook_details": {
            "webhook_version": "1.0.1",
            "webhook_username": "ekart_retail",
            "webhook_password": "password_ekart@123",
            "payment_created_enabled": true,
            "payment_succeeded_enabled": true,
            "payment_failed_enabled": true
        },
        "routing_algorithm": "custom",
        "custom_routing_rules": [
            {
                "payment_methods_incl": [
                    "card",
                    "card"
                ],
                "payment_methods_excl": [
                    "card",
                    "card"
                ],
                "payment_method_types_incl": [
                    "credit"
                ],
                "payment_method_types_excl": [
                    "credit"
                ],
                "payment_method_issuers_incl": [
                    "Citibank",
                    "JPMorgan"
                ],
                "payment_method_issuers_excl": [
                    "Citibank",
                    "JPMorgan"
                ],
                "countries_incl": [
                    "US",
                    "UK",
                    "IN"
                ],
                "countries_excl": [
                    "US",
                    "UK",
                    "IN"
                ],
                "currencies_incl": [
                    "USD",
                    "EUR"
                ],
                "currencies_excl": [
                    "AED",
                    "SGD"
                ],
                "metadata_filters_keys": [
                    "payments.udf1",
                    "payments.udf2"
                ],
                "metadata_filters_values": [
                    "android",
                    "Category_Electronics"
                ],
                "connectors_pecking_order": pgs,
                "connectors_traffic_weightage_key": [
                    "stripe",
                    "adyen",
                    "brain_tree"
                ],
                "connectors_traffic_weightage_value": [
                    50,
                    30,
                    20
                ]
            },
            {
                "payment_methods_incl": [
                    "card",
                    "card"
                ],
                "payment_methods_excl": [
                    "card",
                    "card"
                ],
                "payment_method_types_incl": [
                    "credit"
                ],
                "payment_method_types_excl": [
                    "credit"
                ],
                "payment_method_issuers_incl": [
                    "Citibank",
                    "JPMorgan"
                ],
                "payment_method_issuers_excl": [
                    "Citibank",
                    "JPMorgan"
                ],
                "countries_incl": [
                    "US",
                    "UK",
                    "IN"
                ],
                "countries_excl": [
                    "US",
                    "UK",
                    "IN"
                ],
                "currencies_incl": [
                    "USD",
                    "EUR"
                ],
                "currencies_excl": [
                    "AED",
                    "SGD"
                ],
                "metadata_filters_keys": [
                    "payments.udf1",
                    "payments.udf2"
                ],
                "metadata_filters_values": [
                    "android",
                    "Category_Electronics"
                ],
                "connectors_pecking_order": [
                    "stripe",
                    "adyen",
                    "brain_tree"
                ],
                "connectors_traffic_weightage_key": [
                    "stripe",
                    "adyen",
                    "brain_tree"
                ],
                "connectors_traffic_weightage_value": [
                    50,
                    30,
                    20
                ]
            }
        ],
        "sub_merchants_enabled": false,
        "parent_merchant_id": "xkkdf909012sdjki2dkh5sdf",
        "metadata": {
            "city": "NY",
            "unit": "245"
        }
    });
}



export { getData, getPaymentConnectorCreateData, paymentData, updateMerchantAccount }